// cms modull sliderBrands: Hersteller / Netze / Provider images als Slider
// in desktop und phone sind es unterschiedliche slider
import Splide from '@splidejs/splide';

export class SliderBrands {
    private brandSliders: NodeListOf<Element>;

    constructor() {
        this.brandSliders = document.querySelectorAll('.sliderbrand-data');

        if (this.brandSliders.length > 0) {
            this.initializeSliders();
        }
    }

    private initializeSliders(): void {

        this.brandSliders.forEach((brandSlider) => {
            const container = brandSlider.closest('.cms-module-root');
            const id = brandSlider.getAttribute('data-slider-id');
            const brandLimit = brandSlider.getAttribute('data-slider-limit');
            const type = brandSlider.getAttribute('data-slider-type');
            const rewind = brandSlider.getAttribute('data-slider-rewind');
            const rewindBoolean = (rewind === 'true');

            if (!type || !rewind || !brandLimit || !id) {
                return;
            }

            const limit = parseInt(brandLimit, 10);
            const controls = (limit >= 7 || rewindBoolean === true ? true : false);


            document.querySelectorAll(`#brandSlider-${id}.splide`).forEach(slider => {

                if (!slider.classList.contains('is-initialized')) {
                    slider.classList.add('is-initialized');

                        //  fuer die Desktop-Ansicht
                        new Splide(slider as HTMLElement, {
                            type: type,
                            speed: 500,
                            perPage: 6,
                            perMove: 1,
                            gap: 0,
                            rewind: rewindBoolean,
                            width: '100%',
                            pagination: false,
                            arrows: controls,
                            lazyLoad: 'sequential',
                            classes: {
                                arrows: 'controls tns-controls',
                                prev: 'splide__arrow--prev controls-prev prev',
                                next: 'splide__arrow--next controls-next next',
                            },
                            breakpoints: {
                                1123: {
                                    perPage: 4,
                                    arrows: true,
                                },
                                1289: {
                                    perPage: 5,
                                    arrows: true,
                                },
                            },
                        }).mount();

                }
            });

            document.querySelectorAll(`#brandSliderMobile-${id}.splide`).forEach(slider => {
                // fuer die Mobile-Ansicht
                if (!slider.classList.contains('is-initialized')) {
                    slider.classList.add('is-initialized');
                    new Splide(slider as HTMLElement, {
                        type: type,
                        speed: 500,
                        perPage: 2,
                        perMove: 1,
                        gap: 0,
                        rewind: rewindBoolean,
                        width: '100%',
                        pagination: false,
                        arrows: true,
                        lazyLoad: 'sequential',
                        classes: {
                            arrows: 'controls tns-controls',
                            prev: 'splide__arrow--prev controls-prev prev',
                            next: 'splide__arrow--next controls-next next',
                        },
                    }).mount();
                }
            });
        });
    }
}

